module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    ref: "dialog",
    attrs: {
      "return-value": _vm.date,
      "persistent": "",
      "width": "290px"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.date = $event
      },
      "update:return-value": function($event) {
        _vm.date = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.label,
            "rules": _vm.rules,
            "readonly": "",
            "prepend-icon": "event"
          },
          model: {
            value: (_vm.dateFormatted),
            callback: function($$v) {
              _vm.dateFormatted = $$v
            },
            expression: "dateFormatted"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dialogMenu),
      callback: function($$v) {
        _vm.dialogMenu = $$v
      },
      expression: "dialogMenu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "scrollable": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        return _vm.setData()
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogMenu = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dialog.save(_vm.date)
      }
    }
  }, [_vm._v("\n            OK\n          ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d04372c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-date-dialog.vue
// module id = 615
// module chunks = 0